import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip
} from '@material-ui/core'
import { TFunction } from 'i18next'
import { FC } from 'react'
import { Column } from '../../../types/tables'

interface EnhancedTableHeadProps {
  columnData: Column[]
  orderBy?: string
  setOrderBy: React.Dispatch<React.SetStateAction<string | undefined>>
  order: 'asc' | 'desc'
  setOrder: React.Dispatch<React.SetStateAction<'asc' | 'desc'>>
  t: TFunction
}

const EnhancedTableHead: FC<EnhancedTableHeadProps> = ({
  columnData,
  orderBy,
  setOrderBy,
  order,
  setOrder,
  t
}) => {
  const handeSortRequest = (property: string) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }
  return (
    <TableHead>
      <TableRow>
        {columnData.map(({ id, disablePadding, label, sortable, width }) => {
          return (
            <TableCell
              key={id}
              padding={disablePadding ? 'none' : 'default'}
              sortDirection={orderBy === id ? order : false}
              style={width ? { width } : undefined}
            >
              {sortable ? (
                <Tooltip title='Sort' placement='bottom-start' enterDelay={300}>
                  <TableSortLabel
                    active={orderBy === id}
                    direction={orderBy === id ? order : 'asc'}
                    onClick={() => {
                      handeSortRequest(id)
                    }}
                  >
                    {t(label)}
                  </TableSortLabel>
                </Tooltip>
              ) : (
                t(label)
              )}
            </TableCell>
          )
        })}
      </TableRow>
    </TableHead>
  )
}

export default EnhancedTableHead
